import { useEffect } from 'react';

export const useCaptureGClid = (eventId) => {
    useEffect(() => {
        if (!window || !eventId) return;
        const params = new URLSearchParams(window.location.search);
        const gclid = params.get('gclid');

        if (gclid) {
            localStorage.setItem(`gclid-${eventId}`, gclid);
        }
    }, [eventId]);
};

export const getGclidFromStorage = (eventId) => {
    return localStorage.getItem(`gclid-${eventId}`);
};
